<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="saison_annee_debut">Années début et fin saison</label>
        <label class="input-group-text" for="saison_annee_fin"></label>
      </div>
      <input id="saison_annee_debut"
             v-model="dataForm.annee_debut"
             class="form-control"
             name="saison_annee_debut"
             type="text">
      <input id="saison_annee_fin"
             v-model="dataForm.annee_fin"
             class="form-control"
             name="saison_annee_fin"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="saison_championnat">Championnat</label>
      </div>
      <select id="saison_championnat"
              v-model="dataForm.championnat_id"
              class="custom-select"
              name="saison_championnat">
        <option>Choisissez un championnat...</option>
        <option :key="championnat.championnat_id.slice(5,15)"
                :value="championnat.championnat_id"
                v-for="championnat in championnats">{{ championnat.nom }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text" for="saison_nombre_journees_aller">Nombre de journées (Aller)</label>
      </div>
      <input id="saison_nombre_journees_aller"
             v-model="dataForm.nombre_journees_aller"
             class="form-control"
             name="saison_nombre_journees_aller"
             placeholder="Entrez le nombre de journées à l'aller"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text" for="saison_nombre_journees_retour">Nombre de journées (Retour)</label>
      </div>
      <input id="saison_nombre_journees_retour"
             v-model="dataForm.nombre_journees_retour"
             class="form-control"
             name="saison_nombre_journees_retour"
             placeholder="Entrez le nombre de journées au retour"
             type="number">
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Create",
  props: {},
  data() {
    return {
      championnats: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        annee_debut: '',
        annee_fin: '',
        championnat_id: '',
        nombre_journees_aller: '',
        nombre_journees_retour: '',
        table: 'saisons',
      },
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPostData',
    ]),
    onSubmit() {
      this.axiosPostData(this.dataForm)
          .then((data) => {
            if((data.data.status === 'reussite' && data.status) === 201)
              this.messageSuccess = "Saison ajoutée avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de l'insertion de la saison !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de l'insertion de la saison !"
          })
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    this.axiosGetAllData({
      table: 'championnats'
    })
        .then((data) => {
          this.championnats = data.data
        })
        .catch((data) => {
          this.championnats = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/saisons/components/Create.vue